import type { CustomEventsContext } from '../types'

// data structure: { receipt: Base64 string | undefined, error: string | undefined }

export default function (this: CustomEventsContext, username: string) {
  return this.sendEventWithCallback(
    'subscription.restore.ios',
    { username }
  ).then((data: unknown) => {
    const d = data as { receipt?: string; error?: string }
    if (d.receipt || d.error) {
      return data
    }
    return Promise.reject(
      new Error(this.ERROR_UNKNOWN)
    )
  })
}
